<div class="filter-title">
  <div class="filter-name-wrapper" (click)="toggleFilter()">
    @if (isCollapsable) {
      <rkt-icon class="filter-toggler" [name]="isCollapsed ? 'chevron-right' : 'chevron-down'"></rkt-icon>
    }
    <div class="filter-name">{{ filterName }}</div>
  </div>
  @if (selectedValue && selectedValue !== defaultValue) {
    <button rktButton btnType="danger" class="filter-reset-btn" (click)="changed.emit()">Reset</button>
  }
</div>

@if (!isCollapsed) {
  @for (option of options; track option; let i = $index) {
    <div class="rkt-form-radio">
      <label class="rkt-form-radio-label" [for]="id + '_' + i" [class.disabled]="option.disabled">
        <input
          hidden
          type="radio"
          [id]="id + '_' + i"
          class="rkt-form-radio-input"
          [name]="id"
          [attr.value]="option.value"
          [(ngModel)]="selectedValue"
          (change)="changed.emit(option.value)"
          [value]="option.value"
          [attr.disabled]="option.disabled ? true : null"
        />
        <div class="rkt-form-radio-icon"></div>
        <div class="rkt-form-radio-value">
          {{ option.label }}
        </div>
      </label>
    </div>
  }
}
